import DownloadIcon from '@mui/icons-material/GetApp'
import RefreshIcon from '@mui/icons-material/Refresh'
import { Tooltip } from '@mui/material'
import { useSelector } from 'react-redux'
import { StatusCircle } from '@datasets/dataset-details/datasetHistory/components'
import { formatDate } from '@datasets/dataset-details/datasetHistory/utils'
import { Post, PostStatus, Submission } from '@global/types'
import * as css from './styles'
import { getTooltipTitle } from './utils'
import { t } from '@lingui/core/macro'
import { RootState } from '@redux/store'

interface Props {
  post: Post
  submission: Submission
  rerunDatasetPost: (submission: Submission, post: Post) => void
  downloadPostZip: (post: Post) => void
}

export const Target = ({ post, submission, rerunDatasetPost, downloadPostZip }: Props) => {
  const { target, multi_target, status, updated_at } = post
  const API_DEBUG_ENABLED = useSelector(
    (state: RootState) => state.Auth.features['dataset-details-api-debug'],
  )
  const toolitpTitle = getTooltipTitle(post)

  return (
    <css.Container>
      <css.TargetName>{target.nickname}</css.TargetName>
      <css.MultiTarget>
        {multi_target?.remote_realm_id ? multi_target.remote_realm_id : target?.realm_name} &gt;&gt;{' '}
        {multi_target?.remote_target_id ? multi_target.remote_target_id : target?.remote_target_id}
      </css.MultiTarget>
      {API_DEBUG_ENABLED && (
        <css.ActionIcons>
          <RefreshIcon
            css={css.icon}
            onClick={() => {
              rerunDatasetPost(submission, post)
            }}
          />
          <DownloadIcon
            css={css.icon}
            onClick={() => {
              downloadPostZip(post)
            }}
          />
        </css.ActionIcons>
      )}
      <Tooltip title={toolitpTitle}>
        <css.LastChecked>
          {t`Last checked:`}
          {(status === PostStatus.pending || !status) && (
            <div className="status-indicator small pending" />
          )}
          <StatusCircle status={status} />
          {formatDate(updated_at)}
        </css.LastChecked>
      </Tooltip>
    </css.Container>
  )
}
